import { useEffect, useState } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";


const SobreNos = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    function useIsMobile() {
        const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

        useEffect(() => {
            const handleResize = () => {
                setIsMobile(window.innerWidth <= 768);
            };

            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }, []);

        return isMobile;
    }

    const isMobile = useIsMobile();

    return (
        <>
            <Header active="about" />
            <section style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                <div
                    style={{
                        marginTop: isMobile ? "80px" : "200px",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        padding: isMobile ? "0 20px" : "0"
                    }}
                >
                    <div style={{ width: isMobile ? "100%" : "60%" }}>
                        <h1>METODOLOGIA</h1>

                        <p style={{ textAlign: "justify", marginTop: "35px", fontSize: isMobile ? "16px" : "18px" }}>
                            A FiscalTec é uma consultoria orientada a dados, especializada em operações de alta complexidade contábil e tributária, com forte atuação no processamento e na organização de grandes volumes de informações fiscais.
                        </p>

                        <p style={{ textAlign: "justify", marginTop: "15px", fontSize: isMobile ? "16px" : "18px" }}>
                            Atendemos empresas de médio e grande porte e grupos multinacionais com presença no Brasil, apoiando estruturas corporativas que demandam escala, consistência e alto nível de controle sobre seus dados e decisões.
                        </p>

                        <p style={{ textAlign: "justify", marginTop: "15px", fontSize: isMobile ? "16px" : "18px" }}>
                            Nossa atuação está focada na identificação de oportunidades financeiras relevantes, por meio de análises estruturadas, seguras e alinhadas às melhores práticas de governança corporativa. Trabalhamos de forma integrada às equipes internas, atuando como um parceiro complementar que fortalece a tomada de decisão e reduz riscos.
                        </p>

                        <p style={{ textAlign: "justify", marginTop: "15px", fontSize: isMobile ? "16px" : "18px" }}>
                            Com processos bem definidos e compromisso com resultado, a FiscalTec transforma dados complexos em valor financeiro sustentável, oferecendo segurança, previsibilidade e confiança para organizações que operam em ambientes desafiadores.
                        </p>
                    </div>
                </div>
            </section>
            <section style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "50px" }}>
                <div style={{ width: "100%" }}>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: isMobile ? "column" : "row",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#003c8159",
                            padding: "40px 20px",
                            color: "black",
                            gap: "30px"
                        }}
                    >
                        <div style={{ width: isMobile ? "100%" : "40%" }}>
                            <h1>MISSÃO</h1>
                            <div style={{ width: "130px", height: "3px", backgroundColor: "black" }} />

                            <p style={{ textAlign: "justify", marginTop: "35px", fontSize: isMobile ? "18px" : "22px" }}>
                                Desenvolver atividade e prestar serviços especializados no âmbito fiscal-tributário, aliando em uma única estrutura todos os pilares técnicos essenciais e oferecendo soluções inovadoras epersonalizadas aos clientes e parceiros.
                            </p>
                        </div>

                        <div
                            style={{
                                width: isMobile ? "100%" : "20%",
                                display: "flex",
                                justifyContent: "center"
                            }}
                        >
                            <img
                                src="/assets/missao.png"
                                alt="Missão"
                                style={{ width: isMobile ? "30%" : "50%" }}
                            />
                        </div>
                    </div>
                </div>
            </section>
            <section style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "50px" }}>
                <div style={{ width: "100%" }}>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: isMobile ? "column" : "row",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "40px 20px",
                            color: "black",
                            gap: "30px"
                        }}
                    >
                        <div style={{ width: isMobile ? "100%" : "40%" }}>
                            <h1 style={{ color: "black" }}>VISÃO</h1>
                            <div style={{ width: "100px", height: "3px", backgroundColor: "black" }} />

                            <p style={{ textAlign: "justify", marginTop: "35px", fontSize: isMobile ? "18px" : "22px" }}>
                                Promover o crescimento, o desenvolvimento e a inovação das atividades de forma exemplar, profissional e sustentável, construindo laços sólidos com clientes e parceiros e ser referência nacional em seu ramo de atuação.
                            </p>
                        </div>

                        <div
                            style={{
                                width: isMobile ? "100%" : "20%",
                                display: "flex",
                                justifyContent: "center"
                            }}
                        >
                            <img
                                src="/assets/visao.png"
                                alt="Visão"
                                style={{ width: isMobile ? "30%" : "50%" }}
                            />
                        </div>
                    </div>
                </div>
            </section>
            <section style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "50px" }}>
                <div style={{ width: "100%" }}>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: isMobile ? "column" : "row",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#003c8159",
                            padding: "40px 20px",
                            color: "black",
                            gap: "30px"
                        }}
                    >
                        <div style={{ width: isMobile ? "100%" : "40%" }}>
                            <h1>VALORES</h1>
                            <div style={{ width: "150px", height: "3px", backgroundColor: "black" }} />

                            <p style={{ textAlign: "justify", marginTop: "35px", fontSize: isMobile ? "18px" : "22px" }}>
                                Respeito aos clientes, parceiros, fornecedores e colaboradores; inovação e excelência operacional, Organizacional, com Atendimento Personalizado; Credibilidade e Segurança; Transparência e Sustentabilidade.
                            </p>
                        </div>

                        <div
                            style={{
                                width: isMobile ? "100%" : "20%",
                                display: "flex",
                                justifyContent: "center"
                            }}
                        >
                            <img
                                src="/assets/valores.png"
                                alt="Valores"
                                style={{ width: isMobile ? "30%" : "50%" }}
                            />
                        </div>
                    </div>
                </div>
            </section>
            <hr />
            <Footer />
        </>
    );
}

export default SobreNos;